import mirrorCreator from 'mirror-creator';
import flatten from 'lodash/flatten';

const DEFAULT_ACTION_TYPES = ['REQUEST', 'SUCCESS', 'FAILURE'];
const OPTION_TO_ACTION_MAPPING = {
  c: 'CREATE',
  r: 'FETCH',
  u: 'UPDATE',
  d: 'REMOVE',
};

function getActionsFor(option, resourceName) {
  const actionName = OPTION_TO_ACTION_MAPPING[option];
  return DEFAULT_ACTION_TYPES
    .map(actionType => [actionName, resourceName, actionType].join('_'));
}

// Return mirrorCreator with proper actions
// based on crud param - simple string that tells which parts of CRUD you need
// this method is small helper for baseActionCreators
// examples:
// generateCrudConstants(resourceName, 'RU') - will generate just FETCH & UPDATE actions
// generateCrudConstants(resourceName, 'CRD') - just CREATE & FETCH & REMOVE
export default function generateCrudConstants(resourceName, crud, customActions = []) {
  const options = Array.from(crud.toLowerCase());
  const actions = flatten(
    options.map(option => getActionsFor(option, resourceName))
  ).concat(customActions);
  return mirrorCreator(actions);
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/constants/baseCrudConstants.js